import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import './App.css';
import About from "./components/About";

import Footer from "./components/Footer";
import Journey from "./components/Journey";
import Certificates from "./components/Certificates";




export default function App() {
  return (
    <>
   <div className="master_gradient">
    <Navbar/>
    <Home/>
   <About/>
    <Certificates/>
    <Projects/>
    <Journey/>
  
    
    </div>
   
    <Footer/>
    </>
  )
}